export class StatePopupModel {
    stateId: number;
    stateName: string;
    cityId:number;
}